import { render, staticRenderFns } from "./SvgDiagram.vue?vue&type=template&id=359d2de8"
import script from "./SvgDiagram.ts?vue&type=script&lang=ts&external"
export * from "./SvgDiagram.ts?vue&type=script&lang=ts&external"
import style0 from "./SvgDiagram.vue?vue&type=style&index=0&id=359d2de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports